/* global axios */
import ApiClient from './ApiClient';

class SummaryReportsAPI extends ApiClient {
  constructor() {
    super('summary_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getTeamReports({ since, until, businessHours, excludeIssueTime } = {}) {
    return axios.get(`${this.url}/team`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        exclude_issue_time: excludeIssueTime,
      },
    });
  }

  getVipReports({ since, until, businessHours } = {}) {
    return axios.get(`${this.url}/vip`, {
      params: {
        since,
        until,
        business_hours: businessHours,
      },
    });
  }

  getVipAgentReports({ since, until, businessHours, excludeIssueTime } = {}) {
    return axios.get(`${this.url}/vip_agents`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        exclude_issue_time: excludeIssueTime,
      },
    });
  }

  getAgentReports({ since, until, businessHours, excludeIssueTime } = {}) {
    return axios.get(`${this.url}/agent`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        exclude_issue_time: excludeIssueTime,
      },
    });
  }

  // Get individual sessions for a specific agent (for QA drill-down)
  getAgentSessions({
    userId,
    since,
    until,
    businessHours,
    metricFilter,
    threshold,
    thresholdMax,
    thresholdOperator,
    inboxId,
    sortDirection,
    page,
    perPage,
  } = {}) {
    return axios.get(`${this.url}/agent_sessions`, {
      params: {
        user_id: userId,
        since,
        until,
        business_hours: businessHours,
        metric_filter: metricFilter,
        threshold,
        threshold_max: thresholdMax,
        threshold_operator: thresholdOperator,
        inbox_id: inboxId,
        sort_direction: sortDirection,
        page,
        per_page: perPage,
      },
    });
  }

  getInboxReports({ since, until, businessHours } = {}) {
    return axios.get(`${this.url}/inbox`, {
      params: {
        since,
        until,
        business_hours: businessHours,
      },
    });
  }

  getLabelReports({ since, until, businessHours } = {}) {
    return axios.get(`${this.url}/label`, {
      params: {
        since,
        until,
        business_hours: businessHours,
      },
    });
  }

  getIssueAgentReports({ since, until } = {}) {
    return axios.get(`${this.url}/issue_agents`, {
      params: {
        since,
        until,
      },
    });
  }

  getIssueTypeReports({ since, until } = {}) {
    return axios.get(`${this.url}/issue_types`, {
      params: {
        since,
        until,
      },
    });
  }
}

export default new SummaryReportsAPI();
